export const INDUSTRIES = [
  {
    slug: "hospitals-diagnostics",
    name: "Hospitals & Diagnostics",
    pitch: "Healthcare runs on trust. We build credible digital presences for hospitals, clinics and diagnostic centres — content that educates, websites that reassure, and local visibility that brings patients through the door.",
    points: [
      "Credible, calm social presence that builds patient trust",
      "Educational content systems — doctor videos, health awareness, camp updates",
      "Local SEO so 'near me' searches find you first",
      "Websites that make booking an appointment effortless",
    ],
    services: ["social-media-management", "seo-local-seo", "website-design-development", "content-creation-copywriting"],
    chapters: ["03"],
  },
  {
    slug: "education",
    name: "Education",
    pitch: "Admissions are won on perception. We help schools, academies and course creators turn open days into full classrooms with campaigns parents trust and students actually watch.",
    points: [
      "Admission-season campaign systems across Google and Meta",
      "Reels and video content students actually engage with",
      "Parent-trust content — faculty, results, infrastructure stories",
      "Landing pages and funnels built for enquiry volume",
    ],
    services: ["performance-marketing", "video-editing-ai-content", "social-media-management", "lead-generation-strategy"],
    chapters: ["03"],
  },
  {
    slug: "hotels-resorts",
    name: "Hotels & Resorts",
    pitch: "Guests book the feeling before the room. We create cinematic content, conversion-focused websites and campaigns that turn your property into a destination people plan around.",
    points: [
      "Cinematic property films and reels that sell the experience",
      "Direct-booking websites that reduce OTA dependency",
      "Seasonal campaign and offer promotion systems",
      "Review and reputation content that compounds trust",
    ],
    services: ["website-design-development", "video-editing-ai-content", "social-media-management", "seo-local-seo"],
    chapters: ["04", "03"],
  },
  {
    slug: "villas-home-stays",
    name: "Villas & Home Stays",
    pitch: "Small properties, big presence. We give villas and home stays the branding, photography-grade visuals and booking funnels usually reserved for hotel chains.",
    points: [
      "Identity and story that make your property memorable",
      "AI-enhanced visuals and walkthrough reels",
      "Direct booking pages that cut commission costs",
      "Weekend-getaway campaigns targeting your feeder cities",
    ],
    services: ["website-design-development", "brand-identity-logo-design", "video-editing-ai-content", "performance-marketing"],
    chapters: ["04", "03"],
  },
  {
    slug: "handicrafts",
    name: "Handicrafts",
    pitch: "Handmade deserves world-class storytelling. We help artisan brands move from local markets to global carts with identity, packaging and content that honor the craft.",
    points: [
      "Brand identities rooted in your craft's story",
      "Packaging design that justifies premium pricing",
      "Product content systems for marketplaces and your own store",
      "Export-ready presentations and catalogs",
    ],
    services: ["brand-identity-logo-design", "graphic-design", "website-design-development", "content-creation-copywriting"],
    chapters: ["01", "02"],
  },
  {
    slug: "e-commerce",
    name: "E-Commerce",
    pitch: "Clicks are expensive; conversion is everything. We build the creative engine behind profitable stores — UGC ads, product content, funnels and automation that scale what sells.",
    points: [
      "UGC ad engines with constant creative testing",
      "Product visuals and AI content at catalogue scale",
      "Google & Meta performance systems tuned for ROAS",
      "Chatbots and automation for cart recovery and support",
    ],
    services: ["performance-marketing", "ugc-ads", "video-editing-ai-content", "ai-chatbots-automation"],
    chapters: ["03"],
  },
  {
    slug: "industrial",
    name: "Industrial",
    pitch: "B2B buyers research quietly and decide slowly. We give industrial brands the credible website, sharp identity and lead pipeline that win contracts before the first meeting.",
    points: [
      "Corporate websites that signal scale and reliability",
      "Capability decks, catalogs and trade-show assets",
      "LinkedIn and B2B content that reaches decision-makers",
      "Lead generation systems built for long sales cycles",
    ],
    services: ["website-design-development", "brand-identity-logo-design", "lead-generation-strategy", "content-creation-copywriting"],
    chapters: ["01"],
  },
  {
    slug: "restaurants-cafes",
    name: "Restaurants & Cafes",
    pitch: "Full tables start on full feeds. We turn your food into content people crave — menus, reels and local visibility that convert cravings into covers.",
    points: [
      "Mouth-watering reels and food content systems",
      "Menus, posters and print that elevate the table experience",
      "Google Maps and 'near me' domination",
      "Launch and event campaigns that pack the house",
    ],
    services: ["social-media-management", "video-editing-ai-content", "graphic-design", "seo-local-seo"],
    chapters: ["04", "03"],
  },
  {
    slug: "real-estate",
    name: "Real Estate",
    pitch: "Property is bought on vision and verified on trust. We create the cinematic walkthroughs, project branding and lead systems that move inventory faster.",
    points: [
      "Project launch branding and campaign systems",
      "Drone-style cinematic reels and walkthrough content",
      "High-intent lead funnels with qualification built in",
      "Broker and channel-partner collateral kits",
    ],
    services: ["lead-generation-strategy", "performance-marketing", "video-editing-ai-content", "website-design-development"],
    chapters: ["03", "04"],
  },
  {
    slug: "beauty-fashion",
    name: "Beauty & Fashion",
    pitch: "In beauty and fashion, the feed is the storefront. We build aesthetic-led content engines, influencer pipelines and UGC systems that turn looks into sales.",
    points: [
      "Aesthetic-first social content and campaign shoots",
      "Influencer and creator campaigns managed end to end",
      "UGC ad systems built for conversion",
      "Launch calendars for drops, seasons and collections",
    ],
    services: ["influencer-management-marketing", "social-media-management", "ugc-ads", "video-editing-ai-content"],
    chapters: ["03", "01"],
  },
  {
    slug: "luxury-lifestyle",
    name: "Luxury & Lifestyle",
    pitch: "Luxury is restraint, detail and aura. We craft identities, campaigns and digital experiences with the quiet confidence premium audiences expect.",
    points: [
      "Identities with editorial-grade typography and restraint",
      "Campaign imagery with cinematic production value",
      "Digital experiences that feel like private showrooms",
      "Discreet, high-signal content over noisy posting",
    ],
    services: ["brand-identity-logo-design", "graphic-design", "website-design-development", "video-editing-ai-content"],
    chapters: ["01", "02"],
  },
  {
    slug: "local-businesses",
    name: "Local Businesses",
    pitch: "Your next customer is three streets away, searching right now. We make local businesses unmissable — maps, reviews, social and a website that converts the neighborhood.",
    points: [
      "Google Business Profile and local SEO done properly",
      "Review generation and reputation systems",
      "Simple, fast websites that drive calls and visits",
      "Hyperlocal ad campaigns on realistic budgets",
    ],
    services: ["seo-local-seo", "social-media-management", "website-design-development", "performance-marketing"],
    chapters: ["03"],
  },
  {
    slug: "fitness-wellness",
    name: "Fitness & Wellness",
    pitch: "Transformation sells transformation. We help gyms, studios and wellness brands build communities — challenge campaigns, member stories and content that keeps classes full.",
    points: [
      "Member transformation and community content systems",
      "Challenge and membership campaign funnels",
      "Reels that showcase energy, not just equipment",
      "Chatbots for trial bookings and class enquiries",
    ],
    services: ["social-media-management", "video-editing-ai-content", "lead-generation-strategy", "ai-chatbots-automation"],
    chapters: ["03"],
  },
];
